import React from "react"
import QueueAnim from "rc-queue-anim"
import TweenOne from "rc-tween-one"
import { get } from "lodash"
import { Image, Flex, Box } from "rebass"
import { TextAnimation, defaultSubtitle, defaultTitle } from "./Text"
const LeftImageElement = (props) => {
  const { data, id, matches, widthContainer } = props
  const boxImage = get(data, "position.boxImage", "486px")
  const isAnimation = get(data, "image.isAnimation", false)
  const animationImage = isAnimation
    ? {
        type: get(data, "image.animation.type", "from"),
        ease: get(data, "image.animation.ease", "easeInQuart"),
        opacity: get(data, "image.animation.opacity", 0),
        delay: get(data, "image.animation.delay", 40),
        duration: get(data, "image.animation.duration", 1500),
      }
    : {}

  const useMobile = matches
    ? get(
        data,
        "url_image_mobile",
        get(
          data,
          "url_image",
          "https://via.placeholder.com/400x400?text=400x400=CMS"
        )
      )
    : get(
        data,
        "url_image",
        "https://via.placeholder.com/480x480?text=480x480=CMS"
      )

  const title = get(data, "title", defaultTitle)
  const subtitle = get(data, "subtitle", defaultSubtitle)

  return (
    <Box w={[1]}>
      <QueueAnim name={`Queue-${data.name}-${id}`}>
        <Flex w={[1]} justify={"center"} align={"center"}>
          <Flex
            w={[1]}
            direction={["column", "column", "row"]}
            align={"center"}
            justify={"space-around"}
          >
            <Flex w={[1]}>
              <TweenOne
                className="container-banner-anim"
                animation={animationImage}
                name={`TweenOne-image-left-${data.name}-${id}`}
              >
                <Box w={[1, 1, boxImage]} ml={["0px", "0px", 0]}>
                  <Image src={useMobile} />
                </Box>
              </TweenOne>
            </Flex>
            <Flex w={[1]} direction={"column"} className="text-box-left">
              <TextAnimation data={title} widthContainer={widthContainer} />
              <TextAnimation data={subtitle} widthContainer={widthContainer} />
            </Flex>
          </Flex>
        </Flex>
      </QueueAnim>
    </Box>
  )
}

export default LeftImageElement



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/carouselAnimation/LeftImageElement.js